import { createAsyncThunk } from '@reduxjs/toolkit';

import { getApiErrorMessage } from '../lib/getApiErrorMessage';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

interface DeleteCustomListParams {
    listId: string;
}

export const deleteCustomList = createAsyncThunk<
    string,
    DeleteCustomListParams,
    ThunkConfig<string>
>('customList/deleteCustomList', async ({ listId }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        await extra.api.delete(`/v1/custom-lists/${listId}`);
        return listId;
    } catch (e) {
        return rejectWithValue(String(getApiErrorMessage(e)));
    }
});
